import React from 'react'
import { Icon, IconProps } from './Icon'

export function X(props: Omit<IconProps, 'children'>) {
  return (
    <Icon {...props}>
      <path d="m18 6-12 12" />
      <path d="m6 6 12 12" />
    </Icon>
  )
} 